import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=01f1932e&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f1932e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f1932e')) {
      api.createRecord('01f1932e', component.options)
    } else {
      api.reload('01f1932e', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=01f1932e&scoped=true&", function () {
      api.rerender('01f1932e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NpdVByPznqla/JS/comp/Voucher-Unit.vue"
export default component.exports